import { withErrorHandling } from '@selfserve/react-hocs';
import { CreateAccount } from '../utils/create-account';
import {TFunction} from "i18next";
import * as Yup from "yup";

export const CreateAccountExtended = withErrorHandling(({ openErrorModal }) => {

  const validationSchema = (t: TFunction, isUserExist?: boolean) =>
    Yup.object().shape({
      firstName: Yup.mixed().required(t('common.validations.firstname-required')),
      lastName: Yup.mixed().required(t('common.validations.lastname-required')),
      company: Yup.mixed().required(t('common.validations.company-required')),
      countryCode: Yup.mixed().required(t('common.validations.country-required')),
      jobTitle: Yup.mixed().required(t('common.validations.job-title-required')),
      companySize: Yup.mixed().required(
        t('common.validations.company-size-required')
      ),
      ...(!isUserExist && {
        password: Yup.mixed().required(t('common.validations.password-required')),
        passwordErrors: Yup.object().when('password', (password) => {
          return Yup.object().shape({
            minLengthErr: Yup.mixed().test({
              test: () => !!(password && password.length >= 8),
            }),
            oneNumberErr: Yup.mixed().test({
              test: () => !!(password && /\d/.test(`${password}`)),
            }),
            upperCaseErr: Yup.mixed().test({
              test: () => !!(password && `${password}`.match('.*[A-Z].*')),
            }),
            lowerCaseErr: Yup.mixed().test({
              test: () => !!(password && `${password}`.match('.*[a-z].*')),
            }),
          });
        }),
        confirmPassword: Yup.string().when('password', {
          is: (password: string) => !!password,
          then: Yup.string()
            .required(t('common.validations.confirm-password-required'))
            .oneOf(
              [Yup.ref('password')],
              t('common.validations.confirm-password-match')
            ),
        }),
      }),
    });

  return (
    <CreateAccount isFullForm={true} validationSchema={validationSchema}></CreateAccount>
  );
});
